import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { postBrandTermCondition, putBrandTermCondition } from "../../../services/BrandTermAndCondition/BrandTermAndCondition";
import AdminMenu from "../../AdminMenu";

const BrandTermAndConditionCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {}; // Fallback to prevent undefined errors
  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const [isUpdating, setIsUpdating] = useState(item?.id);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const [input, setInput] = useState({
    termCondition: '',
    status: true,
  });

  useEffect(() => {
    if (item) {
      setInput(prevState => ({
        ...prevState,
        termCondition: item?.termCondition  || '',
        status: item?.status,
      }));
    }
  }, [item]);

  const [termConditionError, setTermConditionError] = useState('');
  const [statusError, setStatusError] = useState('');

  const handleStatusChange = selectedItem => {
    // setStatusValue(selectedItem.value);
    setInput({
      ...input,
      status: selectedItem.value,
    });
  };

  const StatusList = [
    {
      name: 'ACTIVE',
      value: true,
    },
    {
      name: 'INACTIVE',
      value: false,
    },
  ];

  
 
  
  const handleSubmit = () => {
    // Reset all previous errors
    setTermConditionError('');
    setStatusError('');

    let isValid = true;
    if (!input.termCondition) {
      setTermConditionError('Term Condition is Required');
      isValid = false;
    }
    
    // if (!input.status) {
    //   setStatusError('Status is Required');
    //   isValid = false;
    // }
    
    // addBrandOffer;
    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (!isUpdating) {
          // Logic for creating a new pickup request
          const data = {
            brandId: brandId,
            termCondition: input.termCondition,
            status: input.status,
          };
          // Call the service function for creating pickup request
          
          postBrandTermCondition(brandId, data)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  // Reset state variables
                  if (Res.status === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(Res.message);
                    setTimeout(() => {
                      navigate('/BrandTermAndCondition');
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(Res.message);
                  }

                  setInput({
                    termCondition: '',
                    status: '',
                  });

                  setTermConditionError('');
                  setIsSubmitButtonPressed(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        } else {
          const updateData = {
            id: item?.id, // id
            brandId: brandId,
            termCondition: input.termCondition,
            status: input.status,
          };
          // Call the service function for creating pickup request
          putBrandTermCondition(brandId, updateData)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  // Reset state variables
                  if (Res.status === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(Res.message);
                    setTimeout(() => {
                      navigate('/BrandTermAndCondition');
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(Res.message);
                  }

                  setInput({
                    termCondition: '',
                    status: '',
                  });

                  setTermConditionError('');
                  setStatusError('');
                  setIsSubmitButtonPressed(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        }
      }
    } else {
      setIsSubmitButtonPressed(false);
    }
  };


  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/BrandTermAndCondition")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
              Term & Condition {item?.id ? 'Edit ' : 'Create'}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputTextarea
              id="termCondition"
              value={input.termCondition}
              onChange={(e) => {
                if (e.target.value.length <= 500) {
                setInput({
                  ...input,
                  termCondition: e.target.value,
                });
                setTermConditionError("");
              }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {termConditionError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {termConditionError}
              </p>
            )}

            <label
              htmlFor="termCondition"
              className="text-md"
              style={{ color: "blue" }}
            >
              Term & Condition <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>

          <p className="text-lg font-normal" style={{ color: "red" }}>
      {500 - input.termCondition.length} characters left
    </p>

          <p className="text-md font-normal" style={{ color: "red" }}>
              Note : A maximum of 500 characters is allowed.
            </p>
        </div>

        
      </div>
      
      <div className="flex flex-1 mb-3">
          <div className=" mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="statusValue"
                value={input.status}
                onChange={(e) =>
                  setInput({
                    ...input,
                    status: e.value,
                  })
                }
                options={StatusList}
                optionLabel="name"
                placeholder="Status"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {statusError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {statusError}
                </p>
              )}
              <label
                htmlFor="statusValue"
                className="text-md"
                style={{ color: "blue" }}
              >
                Status{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
        </div>
      </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isSubmitButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default BrandTermAndConditionCreate;
